import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CampoAdicionalService } from './campo-adicional.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmarRespuestaType, ConfirmarRespuestaModel } from 'src/app/shared/models/confirmar-respuesta.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { TipoDato } from 'src/app/shared/enumeraciones/tipo-dato.enum';
import {MatDialog} from '@angular/material/dialog';
import { AssociateQuestionsComponent } from './components/associate-questions/associate-questions.component';
//import { AnyMxRecord } from 'dns';

@Component({
	selector: 'app-campo-adicional',
	templateUrl: './campo-adicional.component.html',
	styleUrls: ['./campo-adicional.component.scss']
})
export class CampoAdicionalComponent implements OnInit {
	dataTabla: DatoPaginadoModel;
	headerCampoAdicional: Array<string>;
	formCampoAdicional: FormGroup;
	selectCampoAdicional: any;

	paginaActual: number;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;

	// Selects
	tipoDato: Array<any> = [];
	container: any;
	tipoDatoSelectedText: string;
	listadoRespuesta = [
		{ index: 1, respuesta: 'Si' },
		{ index: 2, respuesta: 'No' }
	];
	idTipoDatoSelected: number;
	dataToEdit: any;

	multipleId : number;
	// multiple feature
	multipleFeatureId : number;
	multipleFeatureJson : Object;

	multipleFeatureCount : number = 0;
	multipleFeatureArray : Array<any> = [];
	multipleFeatureData : Array<any> = [];
	// multiple feature

	campoAdicionalList : Array<any> = [];

	constructor(
		private formBuilder: FormBuilder,
		private campoAdicionalService: CampoAdicionalService,
		private modalService: NgbModal,
		public dialog: MatDialog) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;

		this.createForm();
		this.consultarListas();

		this.onConsultarCampoAdicional(1);

		this.selectCampoAdicional = null;
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.headerCampoAdicional = ['Campo Adicional ID', 'Descripción', 'Tipo dato',
		'Obligatorio', 'Título', 'Estado', 'Acción'];

		this.container = document.getElementById('containerPreguntasMultiples');
		this.getAllCampoAdicional();
	}

	createForm() {
		this.formCampoAdicional = this.formBuilder.group({
			descripcion: [null, Validators.required],
			tipo_dato_id: [null, Validators.required],
			es_obligatorio: [null, Validators.required],
			aplica_comerciante: [false, Validators.requiredTrue],
			aplica_no_comerciante: [false, Validators.requiredTrue],
			Descripcion_Tipo_Dato: [null],
			titulo: [null],
			activo: [true],
			caracateristicas_opciones: [[]]
		});

		this.filtro = this.formBuilder.group({
			descripcion: [null],
			tipo_dato_id: [null],
			es_obligatorio: [null],
			titulo: [null],
			activo: [null],
		});
	}

	getAllCampoAdicional() {
		this.campoAdicionalService.getAll().subscribe(
		(res) => {
			if (res.result) {
			const { data } = res;
			this.campoAdicionalList = data;
			}
		});
	}

	onConsultarCampoAdicional(page: number) {
		this.campoAdicionalService.get({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
					this.catchMultipleDataTypeId();
				}
			});
	}

	catchMultipleDataTypeId() {
		this.dataTabla.items.forEach((item) => {

      if(item.tipo_dato_id == TipoDato.MULTIPLE){
				this.multipleId = item.tipo_dato_id
      }

			/*if (!item.descripcion_tipo_dato.includes('MULTIPLE_CARACTERISTICA')) {
				if (item.descripcion_tipo_dato.includes('MULTIPLE')) {
          console.log('MULTIPLE')
					this.multipleId = item.tipo_dato_id
				}
			}*/
		});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarCampoAdicional(value);
	}

	onAgregarCampoAdicional() {
		let arrayRespuesta = [];
		const inputRespuesta = document.getElementsByName('inputRespuestas[]');

		if(this.idTipoDatoSelected === TipoDato.MULTIPLE){
			for(let i=0; i < inputRespuesta.length; i++){
				let tempInput = inputRespuesta[i] as HTMLInputElement;
				let temp = {
					campo_adicional_opcion_id: 0,
					campo_adicional_id: 0,
					valor: '',
					descripcion: tempInput.value
				};
				arrayRespuesta.push(temp);
			}
		}

		this.formCampoAdicional.value.opciones = arrayRespuesta;
		this.formCampoAdicional.value.descripcion_tipo_dato = this.tipoDatoSelectedText;

		this.campoAdicionalService.create({
			...this.formCampoAdicional.value, activo: 1
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarCampoAdicional(this.paginaActual);
					this.container.classList.add('d-none');
					this.listadoRespuesta.splice(2, this.listadoRespuesta.length);
					this.limpiarCampoAdicional();
				}
			});
	}

	onOperarCampoAdicional() {
		this.formCampoAdicional.controls.caracateristicas_opciones.setValue(this.multipleFeatureResult());
		this.formCampoAdicional.controls.Descripcion_Tipo_Dato.setValue(this.catchDescripcion_Tipo_Dato());

		if (!this.selectCampoAdicional) {
			this.onAgregarCampoAdicional();
		} else {
			this.onModificarCampoAdicional();
		}
	}

	catchDescripcion_Tipo_Dato() {
		let result = null;
		result = this.tipoDato.find(
			(item) => item.tipo_dato_id === Number(this.formCampoAdicional.controls.tipo_dato_id.value)).descripcion;

		return result;
	}

	onCargarCampoAdicional(entry: any) {
		let idComapoAdicional: number = entry.campo_adicional_id;

		this.campoAdicionalService.getById(idComapoAdicional).subscribe((response) => {
			this.dataToEdit = response.data;
			let opcionesRespuesta = this.dataToEdit.opciones;

			this.dataToEdit.activo = entry.activo ? 1 : 0;
			this.dataToEdit.es_obligatorio = entry.es_obligatorio ? 1 : 0;
			this.formCampoAdicional.patchValue({
				...this.dataToEdit
			});

			/* Mostrar el contenedor de respuestas */
			if(this.dataToEdit.tipo_dato_id === TipoDato.MULTIPLE){
				this.container.classList.remove('d-none');
				this.listadoRespuesta = [];

				if(opcionesRespuesta.length > 0){
					for(let i = 0; i < opcionesRespuesta.length; i++){
						let temp = {
							index: this.listadoRespuesta.length + 1,
							respuesta: opcionesRespuesta[i].descripcion
						};

						this.listadoRespuesta.push(temp);
					}
				}
			}
			this.selectCampoAdicional = this.dataToEdit;
			this.commercialResult(this.dataToEdit.aplica_comerciante, 'aplica_comerciante' );
			this.commercialResult(this.dataToEdit.aplica_no_comerciante, 'aplica_no_comerciante' );
		});
	}

	onEliminarCampoAdicional(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.campoAdicionalService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					// tslint:disable-next-line:max-line-length
					// const index = this.dataTabla.items.map(function (e) { return e.campo_adicional_id; }).indexOf(entry.campo_adicional_id);
					// this.dataTabla.items.splice(index, 1);
					this.onConsultarCampoAdicional(this.paginaActual);
					this.selectCampoAdicional = null;
					this.formCampoAdicional.reset();
				}
			});
		});
	}

	openAssociateQuestions( entry? : any ) {
		const dialogRef = this.dialog.open(AssociateQuestionsComponent, {
			data: { entry, list : this.campoAdicionalList }
		});
	}

	onModificarCampoAdicional() {
		const inputRespuesta = document.getElementsByName('inputRespuestas[]');
		let opcionesOld = this.dataToEdit.opciones;
		let arrayRespuestaNew = [];
		let arrayRespuestaEditadas = [];
		this.idTipoDatoSelected = this.dataToEdit.tipo_dato_id;

		/* Obtener el listado de respuestas, cuando tipo de dato MULTIPLE */
		if(this.idTipoDatoSelected === TipoDato.MULTIPLE){
			for(let i=0; i < inputRespuesta.length; i++){
				let tempInput = inputRespuesta[i] as HTMLInputElement;
				let temp = {
					campo_adicional_opcion_id: 0,
					campo_adicional_id: 0,
					valor: '',
					descripcion: tempInput.value
				};
				arrayRespuestaNew.push(temp);
			}
		}

		/* Obtener cambios de las respuestas */
		for(let i=0; i < arrayRespuestaNew.length; i++){
			let descripcionNew = arrayRespuestaNew[i].descripcion;
			let existRespuesta: number = 0;

			for(let j=0; j < opcionesOld.length; j++){
				let descripcionOld = opcionesOld[j];
				let temp: any;

				if(descripcionNew === descripcionOld.descripcion){
					temp = {
						campo_adicional_id: descripcionOld.campo_adicional_id,
						campo_adicional_opcion_id: descripcionOld.campo_adicional_opcion_id,
						descripcion: descripcionOld.descripcion,
						valor: descripcionOld.valor
					};
					arrayRespuestaEditadas.push(temp);
				} else {
					existRespuesta++;
				}
			}

			// Obtener los respuestas nuevas
			if(existRespuesta === opcionesOld.length){
				let tempNew = {
					campo_adicional_opcion_id: 0,
					campo_adicional_id: 0,
					valor: '',
					descripcion: descripcionNew
				};
				arrayRespuestaEditadas.push(tempNew);
			}
		}

		this.formCampoAdicional.value.opciones = arrayRespuestaEditadas;
		this.formCampoAdicional.value.descripcion_tipo_dato = this.dataToEdit.descripcion_tipo_dato;

		this.campoAdicionalService.update({
			...this.formCampoAdicional.value,
			campo_adicional_id: this.selectCampoAdicional.campo_adicional_id
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarCampoAdicional(this.paginaActual);
					this.limpiarCampoAdicional();
					this.selectCampoAdicional = null;
					this.container.classList.add('d-none');
					this.listadoRespuesta.splice(2, this.listadoRespuesta.length);
				}
			});
	}

	consultarListas() {
		this.campoAdicionalService.getTipoDato().subscribe(resultado => {
			if (resultado.data) {
				this.tipoDato = resultado.data;
				this.catchMultipleFeatureId();
			}
		});

		this.campoAdicionalService.getMultipleFeatureData().subscribe((res) => {
			if (res.data) {
				this.multipleFeatureData = res.data;
			}
		})
	}

	// MultipleFeature
	catchMultipleFeatureId() {
		this.multipleFeatureId = this.tipoDato.find(
			(item) => item.descripcion.includes('MULTIPLE_CARACTERISTICA')).tipo_dato_id;
		this.multipleNewInput();
	}

	multipleNewInput() {
		this.multipleFeatureJson = {
			id : this.multipleFeatureCount++,
			descripcion : '',
			caracteristicas_opciones_id : ''
		}
		this.formCampoAdicional.controls.caracateristicas_opciones.setValue(
			[ ...this.formCampoAdicional.controls.caracateristicas_opciones.value, this.multipleFeatureJson ]);
	}

	multipleFeatureChange( e : any, index : number ) {
		const { name, value } = e.target;

		this.formCampoAdicional.controls.caracateristicas_opciones.value[index][name] =
			(name !== 'descripcion') ? Number(value) : value;
	}

	removeMultipleFeature( index : number ) {
		this.formCampoAdicional.controls.caracateristicas_opciones.value.splice(index, 1);
	}

	multipleFeatureResult() {
		let categoryArray = this.formCampoAdicional.controls.caracateristicas_opciones.value.filter(
			(feature : any) => feature.descripcion != '' && delete feature.id);

		return categoryArray;
	}

	multipleFeatureValidation() {
		let multipleValuesFilled = [];
		let validationResult = null;

		multipleValuesFilled = this.formCampoAdicional.controls.caracateristicas_opciones.value.filter(
		(item : any) => item.descripcion && item.caracteristicas_opciones_id);

		(multipleValuesFilled.length > 0 ||
		Number(this.formCampoAdicional.controls.tipo_dato_id.value) !== this.multipleFeatureId)
		? validationResult = true : validationResult = false;

		return validationResult;
	}
	// MultipleFeature

	commercialResult( check? : boolean, commercialType? : string ) {
		if (check) {
		  if (commercialType === 'aplica_comerciante') {
			this.formCampoAdicional.controls['aplica_no_comerciante'].clearValidators();
		  } else {
			this.formCampoAdicional.controls['aplica_comerciante'].clearValidators();
		  }
		} else {
		  if (!this.formCampoAdicional.controls['aplica_comerciante'].value &&
		  !this.formCampoAdicional.controls['aplica_no_comerciante'].value) {

			this.formCampoAdicional.controls['aplica_comerciante'].setValue(false);
			this.formCampoAdicional.controls['aplica_no_comerciante'].setValue(false);

			this.formCampoAdicional.controls['aplica_comerciante'].setValidators(Validators.requiredTrue);
			this.formCampoAdicional.controls['aplica_no_comerciante'].setValidators(Validators.requiredTrue);
		  }
		}

		this.formCampoAdicional.controls['aplica_no_comerciante'].updateValueAndValidity();
		this.formCampoAdicional.controls['aplica_comerciante'].updateValueAndValidity();
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarCampoAdicional(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}

	limpiarCampoAdicional() {
		this.formCampoAdicional.reset();
		this.selectCampoAdicional = null;
		this.createForm();

		this.container.classList.add('d-none');
		this.listadoRespuesta.splice(2, this.listadoRespuesta.length);
	}

	tipoDatoMultiple(event: any){
		this.idTipoDatoSelected = Number(event.currentTarget.value);
		this.tipoDatoSelectedText = event.target.options[event.target.options.selectedIndex].text;

		if(this.idTipoDatoSelected === TipoDato.MULTIPLE){
			this.container.classList.remove('d-none');
		} else{
			this.container.classList.add('d-none');
			this.listadoRespuesta.splice(2, this.listadoRespuesta.length);
		}
	}

	agregarRespuesta(){
		let totalRespuesta = this.listadoRespuesta.length;

		this.listadoRespuesta.push(
			{ index: totalRespuesta + 1, respuesta: '' }
		);
	}

	eliminarRespuesta(index){
		const indexofObject = (this.listadoRespuesta).findIndex((object) => {
			return object.index === index;
		});
		(this.listadoRespuesta).splice(indexofObject, 1);
	}

	crearNuevoCampo(){

	}
}
